import { convertFeet, feetUnit, convertSpeed, speedUnit } from '../units';

export function clamp01(value) {
  return Math.max(0, Math.min(1, value));
}

export function normalizeRange(value, low, high) {
  if (!Number.isFinite(value)) return 0;
  return clamp01((value - low) / Math.max(high - low, 1e-6));
}

export function titleCase(label) {
  if (!label) return '';
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export function formatFeet(value, user) {
  if (value == null || !Number.isFinite(value)) return '--';
  return `${Math.round(convertFeet(Math.abs(value), user))} ${feetUnit(user)}`;
}

export function formatMph(value, user) {
  if (value == null || !Number.isFinite(value)) return '--';
  return `${convertSpeed(Math.abs(value), user).toFixed(1)} ${speedUnit(user).toLowerCase()}`;
}

export function formatSignedMph(value, user) {
  if (value == null || !Number.isFinite(value)) return '--';
  return `${value > 0 ? '+' : ''}${convertSpeed(value, user).toFixed(1)} ${speedUnit(user).toLowerCase()}`;
}

export function average(values) {
  if (!values.length) return null;
  return values.reduce((sum, value) => sum + value, 0) / values.length;
}

export function spread(values) {
  if (!values.length) return null;
  return Math.max(...values) - Math.min(...values);
}
